import Link from '@/components/Link';
import Company from '@/components/companies/Company';
import Search from '@/components/search/Search';
import { MondayItem } from '@/types';
import { Box, Flex, ScrollArea, Text } from '@mantine/core';
import { useState } from 'react';
import { Route, Switch, useParams } from 'wouter';

export default function Companies() {
  const { id } = useParams();
  const [recents, setRecents] = useState<MondayItem[]>([]);
  return (
    <Flex direction="column">
      <Search
        placeholder="Search company by name"
        endpoint="company/search"
        onRecentsLoaded={setRecents}
      />
      <Flex dir="column">
        <ScrollArea
          w="auto"
          flex="1"
          h="calc(100vh - var(--app-shell-header-height, 0px) - 76px) "
        >
          <Switch>
            <Route path="/:id" component={Company} />
            <Route>
              {!id && recents.length > 0 && (
                <Box p="md">
                  <Text>Last visited companies:</Text>
                  {recents.map((r) => (
                    <Link key={r.id} to={`/${r.id}`}>
                      {r.name}
                    </Link>
                  ))}
                </Box>
              )}
              <Text px="md">
                Please use the search filed above to naviagte to desired
                contact.
              </Text>
            </Route>
          </Switch>
        </ScrollArea>
      </Flex>
    </Flex>
  );
}
